<template>
	<div class="bg-h">
		<div style="background: rgba(255, 255, 255, 0.75)">
			<div class="w">
				<div class="HeadbodyMain">
					<div class="logo">
						<div style="display: flex">
							<img src="./../assets/moonsamples/title.png" />
							<!-- <img :src="getLogoConfig.logoImg || defaultTitle" alt style="vertical-align: middle" /> -->
							<!-- <router-link to="/">
						<span class="returnHomeIndex">返回首页</span>
					</router-link> -->
						</div>
					</div>
					<!-- 全局搜索样式i -->
					<template v-if="headertype == '1'"> </template>
					<AppHeader_Navs style="width: 100%"></AppHeader_Navs>
				</div>
			</div>
			<!-- 顶栏容器END -->
			<el-header style="border-bottom: 1px solid rgb(255 255 255 / 20%); overflow: hidden">
				<el-menu :default-active="this.$route.path" mode="horizontal" router style="background-color: transparent">
					<el-menu-item index="/">网站首页</el-menu-item>
					<el-menu-item index="/moonSampleHome">月球样品首页</el-menu-item>
					<el-menu-item index="/moonSample">月球样品查询</el-menu-item>
					<el-menu-item index="/sampleInfoIndex">样品信息说明</el-menu-item>
					<el-menu-item index="/borrowingReturnIndex">借用与返回</el-menu-item>
					<el-menu-item index="/moonSampleAboutUS">关于我们</el-menu-item>
				</el-menu>
			</el-header>
		</div>
		<div class="moonbj">
			<div class="w">
				<div class="imgDivClass">
					<el-carousel arrow="always">
						<el-carousel-item v-for="(item, index) in imgArr" :key="index">
							<div class="imgInforClass">
								<div v-if="index == 0">
									<span class="zhClass">月球样本信息数据库</span>
									<span class="enClass">LUNAR SAMPLE INFORMATION DATABASE</span>
								</div>
								<div class="infoDivClass" v-else>
									<p class="infoClass" v-html="item.description"></p>
								</div>
							</div>
							<img class="imgClass" :src="item.image" />
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>
	</div>
	<!-- <div class="guoji" @click="toguoji"><span style="font-size: 14px; color: #ffffff;">进入国际版</span></div> -->
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import AppHeader_Navs from './AppHeader_Navs.vue'
export default {
	components: { AppHeader_Navs },
	props: {
		type: String
	},
	data() {
		return {
			imgArr: [
				{ name: '', image: require('./../assets/moonsamples/f-bg.png'), description: '' },
				{
					name: '',
					image: require('./../assets/moonsamples/itemBar_01.png'),
					description:
						'嫦娥五号任务是中国探月工程“绕、落、回”三期阶段的收官之战，于2020年11月24日在海南文昌航天发射场成功发射，其着陆器于12月1日成功着陆在位于51.916°W,43.058°N的风暴洋预定着陆区内，在完成月球表面自动采样任务后，其返回舱于12月17日成功在内蒙古四子王旗着陆场着陆，将1731克月球样品带回地球，这是继苏联月球24号之后时隔44年人类再次从月面带回月球样品。'
				},
				{
					name: '',
					image: require('./../assets/moonsamples/itemBar_02.png'),
					description:
						'嫦娥五号着陆点位于月球风暴洋北部的玄武岩区域，该地区的特点是月球火山活动的持续时间较长，并在其内形成了多个地质单元。在成功着陆后，嫦娥五号随即对附近区域开展了形貌探测和地质背景勘察，分别采用钻取和铲取的方式在月球表面进行了取样。'
				},
				{
					name: '',
					image: require('./../assets/moonsamples/itemBar_03.png'),
					description:
						'返回的嫦娥五号月球样品在地面应用系统进行妥善的处理和保管，月球样品将按照探月工程中心《月球样品管理办法》面向全国科学家以及教育、展览单位发布，以开展全面的科学研究活动和公益教育之用，另有一部分月球样品将在湖南进行永久存储。'
				},
				{
					name: '',
					image: require('./../assets/moonsamples/itemBar_04.png'),
					description:
						'嫦娥五号月球样品是我国首次获取的地外采样返回样品，在月球表面的风化作用、火山作用和区域地质背景及演化等许多方面都具有重要的科学研究价值，并为最终解释月球的形成和演化这一根本科学问题提供深化的认识。左侧图为铲取样分样，右侧图为铲取样中的岩屑颗粒。'
				},
				{
					name: '',
					image: require('./../assets/moonsamples/itemBar_05.png'),
					description: '铲取样岩屑样<br> 产品编号：CE5C0800YJYX042<br> 产品特征：角砾质岩屑样<br> 成像设备：Leica M125体视显微镜<br>矿物组成：辉石、斜长石、钛铁矿、橄榄石等'
				}
			],
			defaultTitle: require('@/assets/imgs/newHome/位图.png'),
			searchMessage: '',
			headertype: '1' //默认为1 控制搜索不同功能样式
		}
	},
	computed: {
		...mapGetters(['getActive', 'getLogoConfig', 'getPlatformName'])
	},
	watch: {
		type: {
			immediate: true,
			handler(newName, oldName) {
				this.headertype = newName
			}
		},
		// 获取vuex的tab选中状态
		getActive: function (val) {
			// console.log('获取vuex的tab选中状态', val)
		}
	},
	mounted() {
		this.initImageFunc()
	},
	methods: {
		async initImageFunc() {
			let res = await this.$http.get(this.$const.moonSample.imageList)
			if (res && res.code == 200) {
				this.imgArr = res.data
				this.imgArr.unshift({ name: '', image: require('./../assets/moonsamples/f-bg.png'), description: '' })
			}
		},
		openNewTab() {
			window.open('/#/moonSample', '_blank')
		},
		toguoji() {
			const url = '/toguoji.png'
			window.open(url, '_blank')
		},

		// ...mapActions(["setActive"]),
		async reSearchload() {
			console.log('搜索触发！')
			if (this.searchMessage != '') {
				// 跳转到搜索页面,并传递搜索条件
				console.log(this.searchMessage)
				this.$router.push({
					path: 'search',
					query: { search: this.searchMessage }
				})
				this.searchMessage = ''
			} else {
				this.$router.push({
					name: 'search',
					params: {},
					query: {}
				})
			}
		},
		reSearchloadYX() {
			// if (this.searchMessage != "") {
			//   // 跳转到搜索页面,并传递搜索条件
			//   this.$router.push({ path: "/productSearch", query: { search: this.searchMessage } });
			//   this.searchMessage = "";
			// }
			// 跳转到搜索页面,并传递搜索条件
			let routeData = this.$router.resolve({
				path: '/productSearch',
				query: {
					search: this.searchMessage ? this.searchMessage : ''
				}
			})

			window.open(routeData.href, '_blank')
			// this.$router.push({ path: "/productSearch", query: { search: this.searchMessage ? this.searchMessage : '' } });
			this.searchMessage = ''
		}
	}
}
</script>

<style lang="scss" scoped>
.bg-h {
	display: grid;
	// background-image: url("~@/assets/imgs/newHome/bg.png");
	// background-image: url('~@/assets/moonsamples/sy-bj.png');
	// background-size: 100% 100%; /* 宽度和高度都设置为100% */
	/* 替换为你的背景图URL */
	// background-size: cover;
	/* 背景图按容器比例缩放，保证图片覆盖整个容器 */
	// background-repeat: no-repeat;
	/* 背景图不重复 */
	// background-position: center;
	// height: 713px;
	/* 背景图居中显示 */
}

.guoji {
	height: 41px;
	line-height: 41px;
	cursor: pointer;
	width: 110px;
	text-align: center;
	background: #2469f1;
	position: absolute;
	top: 52px;
	right: 50px;
}
.moonbj {
	background-image: url('~@/assets/moonsamples/moonbj.png');
	background-size: 100% 100%; /* 宽度和高度都设置为100% */
}
/* 顶栏容器CSS */
.HeadbodyMain {
	padding-top: 40px;
	width: 100%;
	display: flex;

	.logo {
		display: flex;
		line-height: 10vh;
		align-items: center;
		flex: 1;
	}
	.returnHomeIndex {
		width: 96px;
		height: 37px;
		background: rgba(255, 255, 255, 0.15);
		color: #fff;
		margin-left: 20px;
		align-items: center;
		display: flex;
		justify-content: center;
		border-radius: 2px;
		border: 1px solid #ffffff;
	}
	.logoText {
		font-size: 36px;
		font-weight: 700;
		color: #1b143c;
		letter-spacing: 1.44px;
		// padding-left: 15px;
		cursor: pointer;
	}

	.so {
		width: 250px;
	}

	.search-frame {
		width: 350px;
		height: 41px;
		display: flex;
		position: relative;
		// border-radius: 4px;
		/* box-sizing: border-box; */
		margin: 50px auto 0;
		border: 2px solid #2469f1;
		border-right: 3px;
	}

	.searchTip {
		position: absolute;
		left: -2px;
		z-index: 999;
		top: 42px;
		width: calc(100% + 4px);
		height: auto;
		padding: 0;
		box-sizing: border-box;
		line-height: 40px;
		background: #edf2f7;
		font-size: 14px;
		color: #757575;
	}

	.searchTip li {
		cursor: pointer;
		text-indent: 10px;
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
	}

	.searchTip li:hover {
		background: #ebebeb;
		color: #2469f1;
	}

	.search-frame-input {
		width: 90%;
		padding-left: 15px;
		border: 0;
		outline: none;
	}

	.search-frame-btn {
		cursor: pointer;
		width: 110px;
		text-align: center;
		line-height: 34px;
		background: #2469f1;
		z-index: 6;
	}

	.search-frame-input:focus {
		border: 1px solid #2469f1;
	}

	.me-search-article-item {
		margin-left: auto;
		margin-right: auto;
		width: 90%;
	}

	.search-condition {
		font-size: 16px;
		font-weight: 400;
		// color: #333333;
		color: #fff;
		line-height: 25px;
		cursor: pointer;
		padding-left: 12px;
		padding-right: 12px;
		margin-right: 25px;
	}

	.search-condition:hover {
		background: linear-gradient(92deg, #735dc4, #619ff9 81%, #2469f1);
		border-radius: 13px;
		color: #fff;
		height: 25px;
		display: inline-block;
	}
}

/* 顶栏容器CSS END */
.el-menu--horizontal {
	border-bottom: 0px;
	> .el-menu-item {
		font-size: 18px;

		color: #fff;
		opacity: 0.5;
		// min-width: 132px;
		text-align: center;

		&.is-active {
			opacity: 1;
			border-bottom: none;
			background: transparent;
			// border-bottom: 3px solid #2469f1 !important;
			// font-weight: 700;
			color: #fff !important;
			position: relative;
			display: inline-block;
		}

		&.is-active::after {
			content: '';
			/* 伪元素需要内容才能生成盒子模型，但这里我们不需要实际的内容 */
			position: absolute;
			/* 绝对定位相对于最近的已定位祖先元素（在这里是 .element-with-bottom-image） */
			left: 0;
			/* 设置左边界 */
			bottom: 0;
			/* 设置底边界 */
			width: 100%;
			/* 宽度与父元素相同 */
			height: 30px;
			/* 高度根据需要调整，这里假设图片高度为30px */
			background-image: url('~@/assets/imgs/newHome/bg4.png');
			/* 替换为你的图片URL */
			background-size: contain;
			/* 根据需要调整图片大小，这里使用contain保持图片比例 */
			background-repeat: no-repeat;
			/* 防止图片重复 */
			background-position: bottom;
			/* 图片居中显示 */
		}

		&:not(.is-disabled):focus,
		&:not(.is-disabled):hover {
			background: transparent;
			color: #fff !important;
			// border-bottom: 3px solid #2469f1 !important;
			// font-weight: 700;
		}
	}

	> ::v-deep .el-submenu {
		width: 128px !important;

		&.is-active {
			> .el-submenu__title {
				// opacity: 0.5;
				// border-bottom: 3px solid #2469f1 !important;
				// font-weight: 700;
				color: #fff !important;
			}
		}

		> .el-submenu__title {
			font-size: 18px;
			color: #fff;
			opacity: 0.5;

			&:hover {
				background: transparent;
				color: #fff;
				// font-weight: 700;
				// border-bottom: 3px solid #2469f1 !important;
			}
		}

		> .el-submenu__title {
			> i {
				display: none;
			}
		}
	}
}

.el-menu--horizontal {
	border-bottom: 0px;
	display: flex;
	width: 1200px;
	margin: 0 auto;
	justify-content: space-between;
}

.imgDivClass:hover .imgInforClass .infoDivClass {
	display: inline;
}
.imgDivClass {
	width: 100%;
	height: 50vh;
	align-items: center;
	margin-top: 4vh;
	.imgClass {
		width: 100%;
		height: 100%;
	}
	.imgClass:hover {
		cursor: pointer;
	}
	.imgInforClass {
		position: absolute;
		padding-left: 100px;
		width: 100%;
		top: 40%;
		.zhClass {
			height: 43px;
			font-family: MicrosoftYaHeiUISemibold;
			font-size: 48px;
			color: #ffffff;
			line-height: 43px;
			text-shadow: 0px 4px 8px #000000;
			text-align: left;
			font-style: normal;
			display: block;
		}
		.enClass {
			padding-top: 30px;
			height: 27px;
			font-family: MicrosoftYaHeiUISemibold;
			font-size: 22px;
			color: #ffffff;
			line-height: 27px;
			text-align: left;
			font-style: normal;
			display: block;
		}

		.infoDivClass {
			width: 62%;
			position: absolute;
			// top: 88px;
			background: rgba(0, 0, 0, 0.4);
			right: 82px;
			padding: 20px 25px;
			display: none;
			.infoClass {
				font-family: '微软雅黑';
				margin: 0px 0 0px 0;
				line-height: 1.5;
				color: #fff;
				font-size: 18px;
			}
		}
	}
}
.el-menu--horizontal > .el-menu-item {
	font-size: 18px;
	color: #000000 !important;
	/* opacity: 0.5; */
}
.el-menu--horizontal > .el-menu-item.is-active,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
	color: #006dd4 !important;
	background: transparent;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
	background: transparent;
	color: #3b58ef !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
	opacity: 1;
	border-bottom: none;
	background: transparent;
	color: #3b58ef !important;
	position: relative;
	display: inline-block;
}
</style>
<style>
.imgDivClass .el-carousel__item h3 {
	color: #475669;
	font-size: 18px;
	opacity: 0.75;
	line-height: 300px;
	margin: 0;
}
.imgDivClass .el-carousel__item:nth-child(2n) {
	background-color: #99a9bf;
}

.imgDivClass .el-carousel__item:nth-child(2n + 1) {
	background-color: #d3dce6;
}
.imgDivClass .el-carousel--horizontal {
	width: 100%;
	height: 100%;
}
.imgDivClass .el-carousel__container {
	position: relative;
	height: 100% !important;
}
</style>